var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadNew = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.061,
    height: 25.065,
    viewBox: "0 0 25.061 25.065",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8024",
    "data-name": "Group 8024",
    transform: "translate(-533.5 -438.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9988",
    "data-name": "Rectangle 9988",
    width: 25.061,
    height: 25.065,
    rx: 2,
    transform: "translate(533.5 438.401)",
    fill: "#e5eaed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-bar-down",
    transform: "translate(536.401 440.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M13.215,10.186a.636.636,0,0,1,0,.9L9.4,14.9a.636.636,0,0,1-.9,0L4.686,11.086a.637.637,0,0,1,.9-.9L8.95,13.552l3.364-3.366a.636.636,0,0,1,.9,0Z",
    transform: "translate(0.679 1.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M9.629,6.815a.636.636,0,0,1,.636.636v8.265a.636.636,0,1,1-1.272,0V7.45A.636.636,0,0,1,9.629,6.815ZM2,3.636A.636.636,0,0,1,2.636,3H16.622a.636.636,0,0,1,0,1.272H2.636A.636.636,0,0,1,2,3.636Z",
    transform: "translate(0)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadNew);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS4wNjEiIGhlaWdodD0iMjUuMDY1IiB2aWV3Qm94PSIwIDAgMjUuMDYxIDI1LjA2NSI+CiAgPGcgaWQ9Ikdyb3VwXzgwMjQiIGRhdGEtbmFtZT0iR3JvdXAgODAyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUzMy41IC00MzguNDAxKSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzk5ODgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDk5ODgiIHdpZHRoPSIyNS4wNjEiIGhlaWdodD0iMjUuMDY1IiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTMzLjUgNDM4LjQwMSkiIGZpbGw9IiNlNWVhZWQiLz4KICAgIDxnIGlkPSJhcnJvdy1iYXItZG93biIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTM2LjQwMSA0NDAuOTM5KSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzkzIiBkYXRhLW5hbWU9IlBhdGggOTMiIGQ9Ik0xMy4yMTUsMTAuMTg2YS42MzYuNjM2LDAsMCwxLDAsLjlMOS40LDE0LjlhLjYzNi42MzYsMCwwLDEtLjksMEw0LjY4NiwxMS4wODZhLjYzNy42MzcsMCwwLDEsLjktLjlMOC45NSwxMy41NTJsMy4zNjQtMy4zNjZhLjYzNi42MzYsMCwwLDEsLjksMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNjc5IDEuOSkiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQiIGRhdGEtbmFtZT0iUGF0aCA5NCIgZD0iTTkuNjI5LDYuODE1YS42MzYuNjM2LDAsMCwxLC42MzYuNjM2djguMjY1YS42MzYuNjM2LDAsMSwxLTEuMjcyLDBWNy40NUEuNjM2LjYzNiwwLDAsMSw5LjYyOSw2LjgxNVpNMiwzLjYzNkEuNjM2LjYzNiwwLDAsMSwyLjYzNiwzSDE2LjYyMmEuNjM2LjYzNiwwLDAsMSwwLDEuMjcySDIuNjM2QS42MzYuNjM2LDAsMCwxLDIsMy42MzZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";